<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col>
          <h1 class="mt-n5">{{ $t('Edit') + ' - ' + $t('Asphalt delivery') }}</h1>
        </v-col>
      </v-row>
      <v-card>
        <v-card-text class="black--text">
          <Field :title="$t('AgreementNo')" :val="delivery.AgreementNo"></Field>
          <Field :title="$t('DeliveryNo')" :val="delivery.No"></Field>
          <Field :title="$t('CustomerName')" :val="delivery.CustomerName"></Field>
          <Field :title="$t('ArticleName')" :val="delivery.ArticleName"></Field>
          <Field :title="$t('Foreman')" :val="delivery.Foreman"></Field>
          <!-- <Field :title="$t('Storage')" :val="delivery.Storage"></Field> -->
          <Field :title="$t('Comment')" :val="delivery.Comment"></Field>
          <Field :title="$t('Earliest load time')" :val="formatDateNonUtc(delivery.LoadTimeEarliest)"></Field>
          <!-- <Field :title="$t('Latest load time')" :val="formatDateNonUtc(delivery.LoadTimeLatest)"></Field> -->
          <Field :title="$t('Amount delivered')" :val="delivery.AmountDelivered+' kg'+' / '+delivery.AmountTotal+' kg'"></Field>

          <v-row no-gutters>
            <v-col cols="10">
              <v-combobox class="mt-0" :disabled="validVehiclesNum.length===0" hide-details multiple deletable-chips chips small-chips :items="validVehiclesNum" v-model="delivery.SelectedVehiclesNum" solo @change="vehiclesChanged"></v-combobox>
              <v-autocomplete class="mt-2" autofocus :items="searchVehiclesNum" v-model="vehicleNum" solo @change="vehicleNumChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Add') + ' ' + $t('Vehicle').toLowerCase()" @focus="focusVehicleNum" :no-data-text="ct.NoDataAvailable"></v-autocomplete>
              <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n8"></v-progress-linear>
            </v-col>
          </v-row>
        </v-card-text>
      <v-card-actions class="mt-n10">
        <v-spacer></v-spacer>
        <v-btn color="success" @click="submit" :loading="submitting" min-width="97px">{{ $t('Save') }}</v-btn>
        <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
      </v-card-actions>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import Field from '@/modules/asphalt-delivery/components/Field'
import formatDate from '@/core/mixins/formatDate'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import { loadVehicles, saveAsphaltDeliveriesDetails } from '@/modules/asphalt-delivery/asphalt-delivery'
import * as DateUtil from '@/core/date'
import ct from '@/core/mixins/common-translations'
import { validSearchKeyUp } from '@/core/utils'

export default {
  mixins: [formatDate, preventLeave, ct],
  components: {
    Field
  },
  data () {
    return {
      loading: true,
      submitting: false,
      valid: true,
      redirectTo: 'asphalt-delivery',
      validVehiclesNum: [], // valid Vehicles LicensePlateNos for for selected facility
      facilityNo: '',
      delivery: {
        AgreementNo: 0,
        No: 0,
        CustomerName: '',
        ArticleName: '',
        Foreman: '',
        LoadTimeLatest: '20000101',
        AmountDelivered: '',
        AmountTotal: '',
        SelectedVehiclesNum: [], // current user-selected LicensePlateNos for vehicles
        Details: []
      },
      searchVehiclesNum: [],
      vehicleNum: '',
      searchVehicle: '',
      searching: false,
      searchTimer: null
    }
  },
  methods: {
    searchDelayed (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 300)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 2) this.searchVehiclesNum = []
      // Temporary show Search vehicle xxx ....
      this.searchVehiclesNum = [this.searchVehicle.length > 1 ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search') + ' ' + this.searchVehicle]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle.length > 1) this.updateVehicles(this.searchVehicle)
    },
    async updateVehicles (searchVehicle) {
      this.searching = true
      if (searchVehicle) {
        const res = await loadVehicles({ facility: this.facilityNo, searchText: searchVehicle, loadDeleted: false })
        if (!res.failed) {
          this.searchVehiclesNum = res.data.map(item => { return item.LicensePlateNo })
          this.searchVehiclesNum = this.searchVehiclesNum.filter(v => !this.delivery.SelectedVehiclesNum.includes(v))
        }
      }
      this.searching = false
    },
    vehicleNumChanged () {
      // Fix selecting "Search" by accident
      if (this.vehicleNum && this.vehicleNum.includes(this.$t('Search'))) {
        this.focusVehicleNum()
      }
      if (this.vehicleNum.trim().length > 0) {
        if (!this.delivery.SelectedVehiclesNum.includes(this.vehicleNum)) {
          if (this.vehicleNum.trim().length > 0) {
            this.delivery.SelectedVehiclesNum.push(this.vehicleNum)
            this.validVehiclesNum = this.delivery.SelectedVehiclesNum
          }
          this.$root.$message.showSuccess(this.$t('Vehicle') + ' ' + this.vehicleNum + ' ' + this.$t('added'))
        }
        this.focusVehicleNum()
      }
    },
    focusVehicleNum () {
      // Temporary show Search
      this.vehicleNum = ''
      this.searchVehicle = ''
      this.searchVehiclesNum = [this.$t('Search')]
    },
    async setSelectedVehicles () {
      // Clear selected
      this.delivery.SelectedVehiclesNum = []
      this.delivery.SelectedVehiclesNum = this.delivery.Details.find(o => o.Name === 'ValidVehicles')?.Data1.split('[').join('').split(']').join('').split(',') ?? []
      this.delivery.SelectedVehiclesNum = this.delivery.SelectedVehiclesNum.filter(v => v !== '')

      // Sort alphabetically
      this.delivery.SelectedVehiclesNum = this.delivery.SelectedVehiclesNum.sort()
      this.validVehiclesNum = this.delivery.SelectedVehiclesNum
    },
    async vehiclesChanged () {
      // Filter out all "bad" user entries (ex. when part searching for LicensePlate) so only valid LicensePlate vehicles are shown
      this.delivery.SelectedVehiclesNum = this.delivery.SelectedVehiclesNum.filter(plateNo => this.validVehiclesNum.includes(plateNo))
      this.$forceUpdate()
      this.preventLeave = true
    },
    async submit () {
      this.preventLeave = false
      this.submitting = true

      // add vehicles licensePlateNo to delivery.Details.'ValidVehicles'.Data1 as ex. "[AA0001],[AA0010],[AA0020]"
      this.delivery.Details = this.delivery.Details.filter(o => o.Name !== 'ValidVehicles')
      this.delivery.Details.push({ Name: 'ValidVehicles', Data1: '[' + this.delivery.SelectedVehiclesNum.join('],[') + ']' })
      this.delivery.UpdatedDate = DateUtil.getRealDate(Date.now())
      const res = await saveAsphaltDeliveriesDetails(this.delivery)
      this.submitting = false
      if (!res.failed) {
        this.$root.$message.showSuccess(this.$t('Vehicles') + ' ' + this.$t('Saved'))
        this.$router.push({ name: this.redirectTo })
      }
    }
  },
  mounted () {
    if (this.$route.params.id) {
      const delivery = this.$route.params.id
      if (delivery.Details) { this.delivery = delivery } else this.delivery.Details = []

      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) this.facilityNo = storedFacilityNo
    }

    this.setSelectedVehicles()

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>
